<script setup>
</script>
<template>
  <main>
    <div class="container">
      <div class="confirmation-wrapper">

        <!-- Left Side: Order Complete -->
        <div class="success-confirmation-box">
          <div class="content-box">
            <div class="success-modal--content mt-4 mb-4">
              <div class="success-modal--icon">
                <i class="fas fa-check"></i>
              </div>
            </div>
            <h3 class="text-center text-shadow page-title mb-1">Order Complete</h3>
            <h5 class="text-center text-shadow paragraph--heading mb-4">Thank you!</h5>
            <a href="/" class="btn btn-gold m-auto">Return to Home</a>
          </div>
        </div>

        <!-- Right Side: Confirmation Details -->
        <div class="main-content-box">
          <div class="top-page-divider">
            <h3 class="page-title text-center">Order Confirmation</h3>
          </div>
          <h3>Thank you for supporting Xalor!</h3>
          <p>
            Thanks to your contribution, we can keep the servers online, support our developers, and grow the community through marketing.
          </p>
          <p>
            <strong>Your tokens should be automatically credited. If you don't see them try to relog.</strong></p>
            <p>If you have encounter any issues, please feel free to
            <a href="https://discord.com/channels/1367631511951769672/1367696662553952266">create a ticket</a>.
          </p>
        </div>

      </div>
    </div>
  </main>
</template>
